import React from 'react'
import { Field } from 'redux-form'
import { StdCard } from 'components'
import FieldInput, { InputType as type } from 'components/SemanticForm'

import { FieldRow } from '../styled'

const TimeOfContract = (props) => {
  const {
    // props
    isCreate=false,
    isEdit=false,
    isDetail=false
  } = props

  return (
    <StdCard title='Time of Contract' style={{ marginTop: '10px' }}>
      <FieldRow>
        <Field 
          name='startDate' 
          label='Start Date'
          type={type.date}
          component={FieldInput}
          editable={!isDetail}
          require
        />
        <Field 
          name='endDate' 
          label='End Date'
          type={type.date}
          component={FieldInput}
          editable={!isDetail}
          require
        />
      </FieldRow>
      <FieldRow>
        <Field 
          name='extendedPeriod' 
          label='Extended Period'
          type={type.text}
          component={FieldInput}
          editable={!isDetail}
        />
        <Field 
          name='penaltyRate' 
          label='Penalty Rate (Baht/day)'
          type={type.text}
          component={FieldInput}
          editable={!isDetail}
          fixedDecimalScale={true}
          decimalScale={2}
        />
      </FieldRow>
      <FieldRow>
        <Field 
          name='dateOfPurpose' 
          label='Date of Purpose'
          className='halfRow'
          type={type.date}
          component={FieldInput}
          editable={!isDetail}
          require
        />
      </FieldRow>
    </StdCard>
  )
}

export default TimeOfContract